export default __webpack_public_path__ + "static/media/logo-name.1d435824.png";